// 🔒 AVISO-CHROME-2026-10-23 — aviso de Chrome viejo en las PC con Windows.
// Mínimo 109: con el browserslist del proyecto y su caniuse-lite (1.0.30001761)
// el Chrome más viejo que cubre la compilación es el 109; y es la última
// versión para Windows 7/8/8.1.
// RECOMENDADO: ~2 meses detrás de la estable del 22/10/2026 (157). Se sube a
// mano cada pocos meses; si se queda viejo, solo avisa de menos (nunca de más).
export const CHROME_MINIMO = 109;
export const CHROME_RECOMENDADO = 153;

// Versión de Chrome en Windows, o null si no es Chrome de verdad en Windows
// (Edge, Opera, Samsung y los demás no se tocan).
export function versionChromeWindows(ua) {
  const s = String(ua || '');
  if (!/Windows/.test(s) || /Edg\/|OPR\/|SamsungBrowser|YaBrowser|Vivaldi/.test(s)) return null;
  const m = s.match(/Chrome\/(\d+)\./);
  return m ? parseInt(m[1], 10) : null;
}

// platformVersion de las Client Hints: "0.x" = Windows 7/8/8.1 (Microsoft Learn).
export function esWindowsViejo(platformVersion) {
  const mayor = parseInt(String(platformVersion || '').split('.')[0], 10);
  return mayor === 0;
}

// Respaldo si no hay Client Hints: "Windows NT 6.x" en el texto del navegador.
export function esWindowsViejoUA(ua) {
  return /Windows NT 6\.[0-3]/.test(String(ua || ''));
}

// 'windows' | 'rojo' | 'amarillo' | null
export function nivelAviso(version, windowsViejo) {
  if (!version) return null;
  if (windowsViejo) return 'windows';
  if (version < CHROME_MINIMO) return 'rojo';
  if (version < CHROME_RECOMENDADO) return 'amarillo';
  return null;
}

// Sin aviso: páginas públicas que ve el cliente del restaurante (tarjeta de
// fidelidad, pagos) y las pantallas de cocina, donde nadie lo toca.
export function rutaSinAviso(pathname) {
  return /^\/(loyalty-card|pay|kitchen|kitchen-tv)(\/|$)/.test(String(pathname || ''));
}

// "Recordar mañana": se guarda el día local (AAAA-MM-DD) en que se pospuso.
export function hoyLocal(d = new Date()) {
  const p = (n) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}
